import { apiClient } from './apiClient';

export interface ContactableMetric {
  total: number;
  callable: number;
  emailable: number;
  filter_url: string;
}

export interface DueTodayMetric {
  total: number;
  scheduled: number;
  first_touch: number;
  filter_url: string;
}

export interface NewThisWeekMetric {
  count: number;
  prior_week_count: number;
  delta: number;
  filter_url: string;
}

export interface ConversionMetric {
  rate: number | null;
  converted: number;
  cohort: number;
  window_days: number;
  filter_url: string;
}

export interface StaleActivityMetric {
  days: number | null;
  threshold: number;
  show: boolean;
}

export interface VisitorsMetric {
  show: boolean;
  count: number;
  window_days: number;
}

export interface TodayPayload {
  generated_at: string;
  contactable: ContactableMetric;
  due_today: DueTodayMetric;
  new_this_week: NewThisWeekMetric;
  conversion: ConversionMetric;
  stale_activity: StaleActivityMetric;
  visitors: VisitorsMetric;
}

export const dashboardService = {
  async getToday(): Promise<TodayPayload> {
    return apiClient.get('/dashboard/today/') as Promise<TodayPayload>;
  },
};
